// extracted by mini-css-extract-plugin
export var boxItems = "_a6-1";
export var boxItemsLg = "_a6-2";
export var button = "_a6-7";
export var buttonHoverless = "_a6-9";
export var buttonLg = "_a6-8";
export var filterGroupBox = "_a6-0";
export var icon = "_a6-3";
export var iconSecondary = "_a6-6";
export var iconWrapper = "_a6-4";
export var iconWrapperLg = "_a6-5";
export var truncatedLabel = "_a6-a";